<template lang="pug">
div
  app-imovel-denominacao(
    :required="true",
    :imovel="cadastro.imovel"
    tipoCadastro="CANCELAMENTO_CLAUSULA_RESOLUTIVA"
  )
  matricula-titulo-imovel(
    :imovel="cadastro.imovel"
    :required="true",
    titulo="Dados da matrícula/título"
    :isLiberacao="true"
  )
  app-documentos(
    :maxSize='25000',
    :valid-extensions="['pdf','rar', 'zip']",
    :documentos="cadastro.imovel.documentos"
    :tiposDocumentos="documentos"
    :tiposDocumentosObrigatorios="documentosObrigatorios"
    :observer="observer",
    aba="Imóvel",
    validateRule='documentosObrigatorios'
  )
</template>

<script>
import AppDocumentos from '../../../../components/cadastro/AppDocumentos'
import { mapActions } from 'vuex'
import AppImovelDenominacao from '../../../../components/cadastro/AppImovelDenominacao'
import AppImovelDadosTitulo from '../../../../components/cadastro/AppImovelDadosTitulo'
import MatriculaTituloImovel from '@/screens/central/cadastros/maranhao/liberacao/components/MatriculaTituloImovel'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'

export default {
  components: {
    AppImovelDenominacao,
    MatriculaTituloImovel,
    AppImovelDadosTitulo,
    AppDocumentos,
    AppLabel,
    AppDivider
  },

  props: ['cadastro', 'observer'],

  async beforeRouteLeave (to, from, next) {
    await this.setDocumentosInteressado()
    await this.observer.validate({ providerName: 'Imóvel/Documentos', skipIfEmpty: false })
    next()
  },

  data () {
    return {
      documentos: [],
      documentosObrigatorios: []
    }
  },

  async created () {
    await this.setDocumentosInteressado()
  },

  methods: {
    ...mapActions({
      findDocumentos: 'tipoDocumento/findTiposDocumento'
    }),

    async setDocumentosInteressado () {
      if ([true, false].includes(this.cadastro.documentoEmitidoAMenos10Anos)) {
        this.documentos = await this.findDocumentos(`cancelamentoClausulaResolutiva/${this.cadastro.documentoEmitidoAMenos10Anos}`)
        this.documentosObrigatorios = this.documentos.filter(documento => {
          return ![
            'OUTROS_IMOVEL', 'COMPROVANTE_PAGAMENTO', 'CERTIDAO_INTEIRO_TEOR',
            'CERTIDAO_CADASTRO_IMOVEL_RURAL', 'IMPOSTO_TERRITORIAL_RURAL',
            'CONTRATO_COMPRA_VENDA', 'CONTA_AGUA_LUZ', 'CERTIDAO_POSSE'].includes(documento.codigo)
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/maranhao/liberacao/components/Imovel.vue